import cartData from './cartData.json';

export default {
    data: cartData
};